<template>

  <Dialog header="Alternative Unit" :modal="true" :visible.sync="displayDialog"
          :style="{width: '60vw'}" :closable=false :contentStyle="{'overflow': 'scroll'}">
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 p-md-6" v-if="this.isPurchaseSales === 'purchase'">
          <DataTable editMode="cell" class="editable-cells-table">
            <Column header="Unit From" field="unitFrom"/>
            <Column header="From Qty" field="unitFromValue">
              <template #editor="slotProps">
                <InputNumber v-model="slotProps.data[slotProps.column.field]" :minFractionDigits="2"
                             :maxFracionDigits="4"/>
              </template>
            </Column>
            <Column header="Unit To" field="unitTo" filterField="unitTo"/>
            <Column header="To Qty" field="unitToValue" filterField="unitToValue">
              <template #editor="slotProps">
                <InputNumber v-model="slotProps.data[slotProps.column.field]" :minFractionDigits="2"
                             :maxFracionDigits="4"/>
              </template>
            </Column>
          </DataTable>
        </div>
      <div class="p-field p-col-12 p-md-12" v-if="this.isPurchaseSales === 'sales'">
        <DataTable editMode="cell" class="editable-cells-table">
          <Column header="Unit From" field="unitFrom"/>
          <Column header="From Qty" field="unitFromValue">
            <template #editor="slotProps">
              <InputNumber v-model="slotProps.data[slotProps.column.field]" :minFractionDigits="2"
                           :maxFracionDigits="4"/>
            </template>
          </Column>
          <Column header="Unit To" field="unitTo" filterField="unitTo"/>
          <Column header="To Qty" field="unitToValue" filterField="unitToValue">
            <template #editor="slotProps">
              <InputNumber v-model="slotProps.data[slotProps.column.field]" :minFractionDigits="2"
                           :maxFracionDigits="4"/>
            </template>
          </Column>
        </DataTable>
      </div>
        <div class="p-field p-col-12 p-md-6" v-if="this.isPurchaseSales === 'purchase'">
          <DataTable editMode="cell" class="editable-cells-table">
            <template #header>
              Formula Table
            </template>
            <Column header="Unit From" field="unitFrom"/>
            <Column header="From Qty" field="unitFromValue">
              <template #editor="slotProps">
                <InputNumber v-model="slotProps.data[slotProps.column.field]" :minFractionDigits="2"
                             :maxFracionDigits="4"/>
              </template>
            </Column>
            <Column header="Unit To" field="unitTo" filterField="unitTo"/>
            <Column header="To Qty" field="unitToValue" filterField="unitToValue">
              <template #editor="slotProps">
                <InputNumber v-model="slotProps.data[slotProps.column.field]" :minFractionDigits="2"
                             :maxFracionDigits="4"/>
              </template>
            </Column>
          </DataTable>

        </div>
      </div>
      <template #footer>
        <Button label="Save" class="p-button-raised p-button-rounded"/>
        <Button label="Cancel" class="p-button-raised p-button-danger"/>
      </template>
  </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Button from 'primevue/button'

export default {
  name: 'UnitConversionDetail',
  data() {
    return {
      displayDialog: false,
      isPurchaseSales: ''
    }
  },
  methods: {
    openDialog(unitConversion) {
      this.isPurchaseSales = unitConversion.isPurchaseSales
      this.displayDialog = true
    }
  },
  components: {
    Dialog,
    DataTable,
    Column,
    Button
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// UnitConversionDetail.vue?58e48234